import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { AlertTriangle, ClipboardCheck, HardHat } from 'lucide-react';
import '../styles/Buttons.css';

const ServiceDashboard: React.FC = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setLoading(false);
  }, [workspaceId]);

  const handleBackToWorkspaces = () => {
    navigate('/workspaces');
  };

  const dashboardCards = [
    {
      title: 'Total Deficiencies',
      value: '0',
      icon: AlertTriangle,
      color: '#F59E0B',
      path: `/workspaces/${workspaceId}/service/deficiencies`
    },
    {
      title: 'Pending Inspections',
      value: '0',
      icon: ClipboardCheck,
      color: '#48182F',
      path: `/workspaces/${workspaceId}/service/inspection`
    },
    {
      title: 'Construction Projects',
      value: '0',
      icon: HardHat,
      color: '#10B981',
      path: `/workspaces/${workspaceId}/service/construction-status`
    },
    {
      title: 'Open Tarion Cases',
      value: '0',
      icon: AlertTriangle,
      color: '#EF4444',
      path: `/workspaces/${workspaceId}/service/tarion`
    }
  ];

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <AppLayout onBack={handleBackToWorkspaces}>
      <div className="page-container">
        <div className="page-header">
          <div>
            <h1 style={{ margin: 0 }}>Service Dashboard</h1>
            <p style={{ fontSize: '14px', color: '#6B7280', margin: '8px 0 0 0' }}>
              Overview of all service activities
            </p>
          </div>
        </div>

        <div className="page-content" style={{ marginTop: '24px' }}>
          {loading ? (
            <div className="builders-loading">
              <div className="builders-loading-spinner" />
            </div>
          ) : (
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 4px 12px rgba(72, 24, 47, 0.15), 0 2px 4px rgba(72, 24, 47, 0.08)'
            }}>
              {/* Dashboard Cards */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '20px',
                marginBottom: '30px'
              }}>
                {dashboardCards.map((card) => {
                  const IconComponent = card.icon;
                  return (
                    <div
                      key={card.title}
                      onClick={() => handleCardClick(card.path)}
                      style={{
                        backgroundColor: '#F5F3F0',
                        border: '1px solid #D4CBC4',
                        borderRadius: '12px',
                        padding: '24px',
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                        boxShadow: '0 2px 4px rgba(72, 24, 47, 0.08)'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(72, 24, 47, 0.15)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.borderColor = '#A89088';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(72, 24, 47, 0.08)';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.borderColor = '#D4CBC4';
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                          <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>
                            {card.title}
                          </p>
                          <p style={{ fontSize: '32px', fontWeight: '700', color: '#48182F', margin: 0 }}>
                            {card.value}
                          </p>
                        </div>
                        <div style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '12px',
                          backgroundColor: `${card.color}15`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <IconComponent size={28} color={card.color} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Recent Activity Section */}
              <div style={{
                backgroundColor: '#F5F3F0',
                border: '1px solid #D4CBC4',
                borderRadius: '12px',
                padding: '24px'
              }}>
                <h2 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  margin: '0 0 16px 0',
                  color: '#48182F'
                }}>
                  Recent Activity
                </h2>
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#6B7280'
                }}>
                  <p>No recent activities to display</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  );
};

export default ServiceDashboard;
